import React from "react";
import DocumentLifeCyclePill from "../../../document/components/DocumentLifeCyclePill";
import { newLineToBr } from "../../../utilities";
import { tryParseJson } from "../../../utilities/jsonUtils";
import { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";

interface CardProps {
  activity: server.dto.ESignActivity
}

const ESignActivityCardContent = (props: CardProps) => {
  const card = Switch(props);

  if (card == null) return null;

  return <div className="margin-left">
    {card}
  </div>;
};

const Switch = (props: CardProps) => {
  const { action, version } = props.activity;
  if (action.value === "lifeCycleToDraft") return <DocumentLifeCyclePill value="draft" />;
  if (action.value === "lifeCycleToReview") return <DocumentLifeCyclePill value="review" />;
  if (action.value === "lifeCycleToOutForSignature") return <DocumentLifeCyclePill value="pending" />;
  if (action.value === "lifeCycleToCompleted") return <DocumentLifeCyclePill value="completed" />;
  if (action.value === "manualComplete") return <DocumentLifeCyclePill value="completed" />;
  if (action.value === "lifeCycleToDiscarded") return <DocumentLifeCyclePill value="discarded" />;

  if (action.value === "startedNewVersion") return <div className="s1_gray"><h3>{RESX.ESign.Version} {version}</h3></div>;

  if (action.value === "checklistItemApproved") return <ChecklistApproved activity={props.activity} />;
  if (action.value === "checklistItemDeclined") return <ChecklistDeclined activity={props.activity} />;

  if (!props.activity.content) return null;

  return <DefaultActivityContent activity={props.activity} />;
};

const ChecklistApproved = (props: CardProps) => {
  const { content } = props.activity;

  if (content == null) return null;

  return <div className="flex">
    <div className="margin-right"><i className="icon-check green small"></i></div>
    <div className="grow1">
      {newLineToBr(content)}
    </div>
  </div>;
};

const ChecklistDeclined = (props: CardProps) => {
  const dto = tryParseJson<server.dto.ChecklistDeclinedActivityContent>(props.activity.content);

  if (dto == null) return null;

  return <>
    <div className="flex">
      <div className="margin-right"><i className="icon-x red small" style={{ fontSize: 13 }}></i></div>
      <div className="grow1">
        {newLineToBr(dto.question)}
      </div>
    </div>

    {(dto.reason != null) && <div className="padding lightred-bg margin-top-small s1_small">
      {newLineToBr(dto.reason)}
    </div>}
  </>;
};

export default ESignActivityCardContent;